import moment from 'moment'
import actions from './actions'
import getters from './getters'
import * as types from './types'

const dateNow = moment().format('YYYY-MM-DD')
const dateNowMinus60 = moment().subtract(60, 'days').format('YYYY-MM-DD')

const getDefaultState = () => {
  return {
    accounts: [],
    accountStatements: [],
    isAccountsLoading: false,
    isAccountStatementsLoading: false,
    filters: {
      companyId: '',
      accountId: '',
      startDate: dateNowMinus60,
      endDate: dateNow,
      type: ''
    },
    pagination: {
      page: 1,
      itemsPerPage: 20
    },
    totalItems: 0
  }
}

const state = getDefaultState()

const mutations = {
  [types.SET_ACCOUNT_STATEMENTS](state, accountStatements) {
    state.accountStatements = accountStatements
  },
  [types.SET_IS_ACCOUNT_STATEMENTS_LOADING](state, isLoading) {
    state.isAccountStatementsLoading = isLoading
  },
  [types.SET_TOTAL_ITEMS](state, totalItems) {
    state.totalItems = totalItems
  },
  [types.SET_PAGINATION](state, pagination) {
    state.pagination = pagination
  },
  [types.SET_FILTERS](state, { key, value }) {
    state.filters = {
      ...state.filters,
      [key]: value
    }
  },
  [types.SET_ACCOUNTS](state, accounts) {
    state.accounts = accounts
  },
  [types.CLEAR_ACCOUNTS](state) {
    state.accounts = []
    state.filters.accountId = ''
  },
  [types.SET_IS_ACCOUNTS_LOADING](state, isLoading) {
    state.isAccountsLoading = isLoading
  },
  [types.SET_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
